module.exports = "/static/assets/2b4fc8139d14625129d9fc6b9924d2c8.png";